import type { Item } from 'shared-types';
import type { SelectionGroupType, SelectionOrExtraType, SelectionType } from 'shared-types/Basket';
import { formatExtraLabel } from './formatExtraLabel';
import { formatTime } from './formatTime';

type WithSelectionGroups = Pick<Item, 'selectionGroups'>;

const choiceSelections = (item: WithSelectionGroups): SelectionType[] =>
  (Array.isArray(item.selectionGroups) ? (item.selectionGroups as SelectionOrExtraType[]) : [])
    .filter((group): group is SelectionGroupType => !!group && !group.isExtras)
    .flatMap((group) => (Array.isArray(group.selections) ? group.selections : []));

export const spaChoiceLines = (item: WithSelectionGroups): string[] => {
  const choices = new Map<string, { name: string; time?: string; count: number }>();

  choiceSelections(item).forEach((selection) => {
    if (!selection?.name) return;
    const time = selection.startTime ? formatTime(selection.startTime) : undefined;
    const key = `${time ?? ''}|${selection.name}`;
    const choice = choices.get(key) ?? { name: selection.name, time, count: 0 };
    choice.count += 1;
    choices.set(key, choice);
  });

  return [...choices.values()]
    .sort((a, b) => (a.time ?? '').localeCompare(b.time ?? ''))
    .map(({ name, time, count }) =>
      [formatExtraLabel(name, count), time].filter(Boolean).join(' · ')
    );
};

export const firstSpaChoiceTime = (item: WithSelectionGroups): string | undefined =>
  choiceSelections(item)
    .map((selection) => (selection?.startTime ? formatTime(selection.startTime) : undefined))
    .filter((time): time is string => Boolean(time))
    .sort()[0];
